import { useSelector } from "react-redux";

const useSideBarMenus = () => {
  const { currentUser } = useSelector((state) => state.store);

  const deliveryBusinessName = currentUser?.delivery_business?.name || "Ecommerce";
  const isEcommerce = deliveryBusinessName === "Ecommerce";

  const data = [
    {
      icon: "BsShop",
      title: "Dashboard",
      path: "dashboard",
    },

    {
      icon: "SlNotebook",
      title: "Order",
      path: "order/all-orders",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Order",
          accordianmenu: [
            { title: "All", path: "order/all-orders", icon: "MdContentPaste" },
            { title: "Pending", path: "order/pending-orders", icon: "GiSandsOfTime" },
            { title: "Accepted", path: "order/accepted-orders", icon: "MdToday" },
            { title: "Dispatch", path: "order/dispatch", icon: "BsCartCheckFill" },
            {
              title: "Assign to Deliveryman",
              path: "order/assign-to-deliveryman",
              icon: "BsCartCheckFill",
            },
            { title: "Delivered", path: "order/delivered-orders", icon: "CiDeliveryTruck" },
            { title: "Cancel", path: "order/cancel-order", icon: "MdOutlineCancel" },
            { title: "Replacement", path: "order/replacement", icon: "TbZoomReplace" },
          ],
        },
        {
          accordianTitle: "Returns",
          accordianmenu: [
            { title: "All Returns", path: "order/all-return-order", icon: "TbTruckReturn" },
            {
              title: "Pending Returns",
              path: "order/pending-return-order",
              icon: "TbTruckReturn",
            },
            {
              title: "Accepted Returns",
              path: "order/accept-return-order",
              icon: "TbTruckReturn",
            },
            { title: "Returned", path: "order/returned-order", icon: "TbTruckReturn" },
          ],
        },
      ],
    },

    {
      icon: "GiCoins",
      title: "Earning",
      path: "earning/order",
      submenu: [
        {
          icon: "AiOutlineProduct",
          title: "Earning",
          path: "earning/order",
        },
      ],
      accordian: [],
    },

    {
      icon: "SlNotebook",
      title: "Catalogue",
      path: isEcommerce ? "menu/item-list" : "menu/item-food-list",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Catalogue",
          accordianmenu: [
            { icon: "LuBoxes", title: "Category", path: "menu/category" },
            isEcommerce
              ? { icon: "CgNotes", title: "Item", path: "menu/item-list" }
              : { icon: "CgNotes", title: "Food Item", path: "menu/item-food-list" },
          ],
        },

        // Only show Modifier section for non-ecommerce
        !isEcommerce && {
          accordianTitle: "Modifier",
          accordianmenu: [
            {
              icon: "SiModin",
              title: "Modifier Category",
              path: "menu/modifier-group",
            },
          ],
        },
      ].filter(Boolean),
    },

    {
      icon: "IoStarOutline",
      title: "Reviews",
      path: "reviews",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Reviews",
          accordianmenu: [{ icon: "IoStarOutline", title: "Reviews", path: "reviews" }],
        },
      ],
    },
    {
      icon: "IoStarOutline",
      title: "Complaints",
      path: "complaints",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Complaints",
          accordianmenu: [{ icon: "IoStarOutline", title: "Complaints", path: "complaints" }],
        },
      ],
    },

    {
      icon: "SlNotebook",
      title: "Inventory",
      path: "inventory/grv",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Inventery",
          accordianmenu: [
            { icon: "FaSitemap", title: "Goods Receipt Voucher", path: "inventory/grv" },
            { icon: "CgNotes", title: "Goods Issue Voucher", path: "inventory/giv" },
          ],
        },
        {
          accordianTitle: "Report",
          accordianmenu: [
            {
              icon: "CgNotes",
              title: "Stocks On Hand Report",
              path: "inventory/stock-on-hand-report",
            },
            {
              icon: "CgNotes",
              title: "Stocks Ledger Report",
              path: "inventory/stock-ledger-report",
            },
          ],
        },
      ],
    },

    {
      icon: "AiOutlineTag",
      title: "Offers",
      path: "offers/promocode",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Offers",
          accordianmenu: [
            { icon: "RiCoupon3Line", title: "Create Promo", path: "offers/promocode" },
            { icon: "FaStore", title: "Create Sale", path: "offers/sale" },
          ],
        },
      ],
    },

    {
      icon: "RiAdvertisementLine",
      title: "Advertisement",
      path: "Promotion/advertisement-management",
      submenu: [
        {
          icon: "RiAdvertisementLine",
          title: "Advertise Management",
          path: "Promotion/advertisement-management",
        },
      ],
      accordian: [],
    },

    {
      icon: "SlNotebook",
      title: "Approvals",
      path: "approvals/category",
      submenu: [],
      accordian: [
        {
          accordianTitle: "Menu",
          accordianmenu: [
            { icon: "LuBoxes", title: "Category", path: "approvals/category" },
            { icon: "BiCategoryAlt", title: "Subcategory", path: "approvals/sub-category" },
            { title: "Item", path: "approvals/item", icon: "MdToday" },
          ],
        },
        {
          accordianTitle: "Offer",
          accordianmenu: [
            { title: "Promo-code approval", path: "approvals/promo-code", icon: "RiCoupon3Line" },
            { title: "Sale approval", path: "approvals/sale", icon: "FaStore" },
          ],
        },
        {
          accordianTitle: "Advertisment",
          accordianmenu: [
            { title: "Advertise", path: "approvals/advertise", icon: "RiAdvertisementLine" },
          ],
        },
        {
          accordianTitle: "Rejections",
          accordianmenu: [
            { title: "Category", path: "approvals/category-reject", icon: "LuBoxes" },
            { title: "Subcategory", path: "approvals/subcategory-reject", icon: "BiCategoryAlt" },
            { title: "Item", path: "approvals/item-reject", icon: "MdToday" },
            { title: "Promo Code", path: "approvals/promo-code-reject", icon: "RiCoupon3Line" },
            { title: "Sales", path: "approvals/sale-reject", icon: "AiOutlineTag" },
            { title: "Advertise", path: "approvals/advertise-reject", icon: "RiAdvertisementLine" },
          ],
        },
      ],
    },

    // ✅ Hide Settings menu when business is Ecommerce
    !isEcommerce && {
      icon: "CiSettings",
      title: "Settings",
      path: "settings/store-settings",
      submenu: [
        {
          icon: "CiSettings",
          title: "Store Settings",
          path: "settings/store-settings",
        },
      ],
      accordian: [],
    },
  ].filter(Boolean);

  return data;
};

export default useSideBarMenus;
